import React, { FC, useState } from 'react';
import { IconTooltip, Text } from 'wix-ui-tpa/cssVars';
import { Info } from '@wix/wix-ui-icons-common/on-stage';
import { classes } from './DiscountName.st.css';
import { DataHooks } from './consts';
import { useTranslation } from '@wix/yoshi-flow-editor';

export type DiscountNameProps = {
  discountName?: string;
  showTooltip?: boolean;
  tooltipMessage?: string;
};

export const DiscountName: FC<DiscountNameProps> = ({
  discountName,
  showTooltip,
  tooltipMessage,
}) => {
  const { t } = useTranslation();
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  if (!discountName) {
    return null;
  }

  return (
    <div data-hook={DataHooks.ROOT} className={classes.root}>
      <Text>{discountName}</Text>
      {showTooltip && (
        <IconTooltip
          style={{ color: 'rgb(var(--discountNameColor))' }}
          data-hook={DataHooks.TOOLTIP}
          showTooltip={isTooltipVisible}
          onMouseEnter={() => setIsTooltipVisible(true)}
          onFocus={() => setIsTooltipVisible(true)}
          onBlur={() => setIsTooltipVisible(false)}
          tooltipProps={{ onHide: () => setIsTooltipVisible(false) }}
          icon={<Info aria-hidden="true" />}
          message={tooltipMessage ?? t('service-list.widget.discount-tooltip')}
        />
      )}
    </div>
  );
};
